<template>
  <div class="list-detail-item" @click="handle(item.detail_mobile_url)">
    <h4 class="ell">【{{ item.category_name }}】{{ item.item_name }}</h4>
    <div class="info">
      <p class="ell">发起时间: {{ item.send_time }}</p>
      <p class="ell">发起人: {{ item.sender_name }}</p>
      <p class="ell" v-if="type == 'receivedGridExample'">接收时间: {{ item.receive_time }}</p>
      <p class="ell" v-if="type == 'sendGridEximpl'">办理时间：{{ item.handle_time }}</p>
      <p class="ell" v-if="type == 'sendMyGridEximpl'">接收时间: {{ item.notify_time }}</p>
      <p class="ell">来源: {{ item.source_name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListDetailItem",
  props: ['item', 'type']
//  this.type == 'sendGridEximpl'? querysendGridEximplListNew :
//   this.type == 'initiatedEximpl'? initiatedEximplPublicPage : querysendMyGridEximplPublicPage;
}
</script>

<style lang="scss" scoped>
.list-detail-item{
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  background: #fff;
  h4 {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
  }
  .info{
    display: flex;
    flex-wrap: wrap;
    p{
      width: 60%;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #999;
      box-sizing: border-box;
      flex-shrink: 0;
      &:nth-child(2n) {
        width: 40%;
        padding-left: 10px;
        text-align: right;
      }
    }
  }
}
.ell{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
